export default "__VITE_ASSET__Cx36zPch__"